import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { style: {"margin-bottom":"20px"} }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "item-desc" }, "延时方式", -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode("固定时长")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("自动计算")
const _hoisted_5 = { key: 0 }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "item-desc" }, " 后进入下一步", -1)
const _hoisted_7 = {
  key: 1,
  class: "item-desc"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "item-desc" }, " 后进入下一步", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_radio_button = _resolveComponent("el-radio-button")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_time_picker = _resolveComponent("el-time-picker")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createVNode(_component_el_radio_group, {
        modelValue: _ctx.config.type,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.config.type) = $event)),
        size: "small"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_radio_button, { label: "FIXED" }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          }),
          _createVNode(_component_el_radio_button, { label: "AUTO" }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    (_ctx.config.type === 'FIXED')
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createVNode(_component_el_input, {
            style: {"width":"180px"},
            placeholder: "时间单位",
            size: "small",
            type: "number",
            modelValue: _ctx.config.time,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.config.time) = $event))
          }, {
            append: _withCtx(() => [
              _createVNode(_component_el_select, {
                style: {"width":"75px"},
                modelValue: _ctx.config.unit,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.config.unit) = $event)),
                placeholder: "请选择"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_option, {
                    label: "天",
                    value: "D"
                  }),
                  _createVNode(_component_el_option, {
                    label: "小时",
                    value: "H"
                  }),
                  _createVNode(_component_el_option, {
                    label: "分钟",
                    value: "M"
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _hoisted_6
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createVNode(_component_el_time_picker, {
            "value-format": "HH:mm:ss",
            style: {"width":"150px"},
            size: "small",
            modelValue: _ctx.config.dateTime,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.config.dateTime) = $event)),
            placeholder: "任意时间点"
          }, null, 8, ["modelValue"]),
          _hoisted_8
        ]))
  ]))
}